import { darken } from 'polished';
import styled from 'styled-components';

import alert from '../../../assets/alert.svg';
import background from '../../../assets/background_auth.png';
import colors from '../../../styles/colors';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #f2f2f2;
  color: #4d4d4d;
`;

export const Wrapper = styled.div`
  width: 100%;
  background: #fff;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  flex-direction: row-reverse;
`;

export const Content = styled.div`
  width: calc(100% - 422px);
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  form {
    width: 380px;
    h1 {
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      margin-bottom: 30px;
    }
    label {
      font-weight: bold;
    }
    input[type='email'],
    input[type='password'] {
      width: 100%;
      border-radius: 5px;
      border: 1px solid ${colors.gray};
      background: transparent;
      height: 44px;
      padding: 0 15px;
      margin: 10px 0;
      transition: border 0.3s;
      &::placeholder {
        color: ${colors.gray};
      }
      &:focus {
        border: solid 1px ${colors.darkgray};
      }
    }
    span {
      color: #c11e1e;
      margin-bottom: 20px;
    }
    span:before {
      content: url(${alert});
      padding: 0 10px 0 0;
      vertical-align: -10%;
    }
    button {
      width: 100%;
      height: 48px;
      border-radius: 5px;
      border: none;
      background: #eb0045;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.3rem;
      text-align: center;
      text-transform: uppercase;
      color: #fff;
      transition: background 0.2s;
      &:hover {
        background: ${darken(0.03, '#eb0045')};
      }
    }
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 840px) {
    width: 100%;
    form {
      padding: 0 20px;
    }
  }
`;
export const ContentImage = styled.div`
  width: 422px;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 40px;
  img {
    align-self: flex-start;
  }
  p {
    margin: 20px 0;
    max-width: 240px;
    line-height: 1.5em;
    color: #fff;
    font-size: 20px;
  }
  @media (max-width: 840px) {
    display: none;
  }
`;
